export class RosterAccessProgress {
    constructor(
        public value: number = 100
    ) { }
}
